<template>
  <div
    v-if="isVisible"
    class="col-12"
    :class="{
      [`col-md-${colWidth}`]: colWidth,
    }"
  >
    <slot v-if="slotName"></slot>
    <TextSection v-else v-bind="{ title, description }" />
  </div>
</template>

<script>
import TextSection from '@/components/text/TextSection';
export default {
  name: 'AccountPanelCol',
  components: {
    TextSection,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    slotName: {
      type: String,
      default: '',
    },
    colWidth: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    isVisible() {
      return this.slotName || (this.title && this.description);
    },
  },
};
</script>
